<template>
  <v-row>
    <v-col>
      <v-card color="#fdbe43">
        <v-form ref="form" style="padding:3%;" @submit.prevent="handleSubmit()">
          <v-row>
            <v-col :cols="cols">
              <v-text-field v-model="fname" outlined label="First Name" />
            </v-col>
            <v-col :cols="cols">
              <v-text-field v-model="lname" outlined label="Last Name" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="email" outlined label="Email Address" />
            </v-col>
          </v-row>
          <!-- <v-text-field
            outlined
            label="Zip Code"
            v-model="zipCode"
          ></v-text-field> -->
          <v-btn color="blue" class="center" type="submit">
            <h3 id="button-text">
              Stay in touch
            </h3>
          </v-btn>
        </v-form>
      </v-card>
    </v-col>
    <v-dialog
      :value="showNotification"
      :width="modalWidth"
      transition="scale-transition"
      @click:outside="closeModal"
    >
      <v-card style="padding: 5%; background: #0092d0;">
        <v-row justify="center">
          <v-col class="text-center">
            <h1 id="notification">
              {{ notificationText }}
            </h1>
            <!-- <h1 style="color:white;">You are now</h1> -->
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col class="text-center">
            <v-btn id="ok-button" @click="closeModal">
              OK
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
// import router from "vue-router";
import axios from "axios";
import md5 from "md5";
import { tags } from "../../data/mailchimpTags";

// associated lambda:
// https://us-east-2.console.aws.amazon.com/lambda/home?region=us-east-2#/functions/MC-add-and-tag-member?tab=code

const subscribeUrl =
  "https://h9eip0tim6.execute-api.us-east-2.amazonaws.com/dev/subscribe";
const getMembersUrl =
  "https://h9eip0tim6.execute-api.us-east-2.amazonaws.com/dev/members";
const getListDataUrl =
  "https://h9eip0tim6.execute-api.us-east-2.amazonaws.com/dev/list";
const succesMessage = "You are now subscribed for email updates.";
const errorMessage = "Something went wrong. <br> Please try again.";

export default Vue.extend({
  props: ["currentProject"],
  data() {
    return {
      fname: "",
      lname: "",
      email: "",
      zipCode: "",
      newSubscriber: null,
      newSubscriberId: "",
      notificationText: "",
      showNotification: false,
      subscribers: null,
      listData: null,
      tags,
      tagName: ""
    };
  },
  computed: {
    modalWidth() {
      const breakPoint = this.$vuetify.breakpoint.name;
      let width;
      switch (breakPoint) {
        case "xl":
          width = "30%";
          break;
        case "lg":
          width = "30%";
          break;
        case "md":
          width = "50%";
          break;
        case "sm":
          width = "80%";
          break;
        case "xs":
          width = "80%";
          break;
        default:
          width = "60%";
      }
      return width;
    },
    cols() {
      if (this.$vuetify.breakpoint.name === "xs") {
        return "12";
      }
      return "6";
    }
  },
  mounted() {
    this.getSubscribers();
    this.getListData();
  },
  async created() {
    // const tag = await this.setCurrentTag(this.$route.params.id);
    // if (tag) {
    //   this.tagName = tag.name;
    // }
  },
  methods: {
    async getSubscribers() {
      const response = await axios.get(getMembersUrl);
      const data = await response.data;
      const members = await data.members;
      this.subscribers = members;
      return this.subscribers;
    },
    async getListData() {
      const response = await axios.get(getListDataUrl);
      const data = await response.data;
      this.listData = data;
      return this.listData;
    },
    async handleSubmit() {
      this.subscribeToUpdates();
    },
    subscribeToUpdates() {
      this.checkIfMember(this.email);
      const body = {
        email: this.email,
        hashedEmail: md5(this.email),
        fname: this.fname || "Subscriber",
        lname: this.lname || "",
        tagName: "Campbellton Corridor Transit Project"
      };
      // make sure body is correct
      if (this.emailValid(this.email)) {
        // check body here
        axios
          .post(subscribeUrl, body)
          .then(response => {
            this.notificationText = succesMessage;
            this.setNewMember(response.data);
          })
          .catch(error => {
            this.notificationText = errorMessage;
            console.log("Something went wrong: ", error);
          })
          .finally(() => this.showNotificationPopup());
      } else {
        this.notificationText = "Invalid email. Please try again.";
        this.showNotificationPopup();
      }
    },
    setNewMember(data) {
      this.newSubscriber = data;
      this.newSubscriberId = data.id;
    },
    showNotificationPopup() {
      this.closeModal();
      this.showNotification = true;
    },
    closeModal() {
      this.fname = "";
      this.lname = "";
      this.email = "";
      this.zipCode = "";
      this.showNotification = false;
      this.hideModal();
    },
    emailValid(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    // goToDocLibrary(projectId) {
    //   router.push({ path: `/projects/${projectId}/documentLibrary` });
    // },
    hideModal() {
      console.log("something");
    },
    async checkIfMember(email) {
      const subData = await this.getSubscribers();
      const subs = JSON.parse(JSON.stringify(subData));
      const isMember = !!subs.find(s => s.email_address === email);
      return isMember;
    },
    async setCurrentTag(projectId) {
      const tag = await this.tags.find(tag => tag.projectId === projectId);
      return tag;
    }
  }
});
</script>

<style scoped>
div.col {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  margin-top: 0 !important;
}
#notification {
  font-family: "helvetica-neue-roman", "Helvetica", "Arial", "sans-serif" !important;
  color: white;
}
#ok-button {
  background: #0092d0;
  color: white;
  font-size: 20px !important;
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif" !important;
}
.v-form,
.v-text-field {
  font-family: "helvetica-neue-roman", "Helvetica", "Arial", "sans-serif" !important;
}
li {
  text-decoration: underline !important;
}
img {
  width: 10em !important;
}
p {
  padding: 0% 1% 0% 1%;
  font-size: 1.1em;
  font-family: "helvetica-neue-roman", "Helvetica", "Arial", "sans-serif" !important;
  text-align: left;
}
span {
  font-size: 1.1em;
  font-family: "helvetica-neue-roman", "Helvetica", "Arial", "sans-serif" !important;
}
.button-text {
  font-size: 1.6em !important;
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif";
}
#here {
  font-size: 0.6em !important;
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif" !important;
}
.blue-text {
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif" !important;
  font-size: 1.5em;
  padding: 0.5% 0% 0% 1%;
  color: #0092d0;
}
h1.orange-text {
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif";
  font-size: 1.7em;
  color: #ff7500;
}
p.orange-text {
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif";
  font-size: 1.7em;
  color: #ff7500;
}
#button-text {
  /* font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif"; */
  font-size: 1.5em;
  color: white;
  text-align: center;
}
.white-text {
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif";
  font-size: 2em;
  color: white;
}
.black-text-small {
  padding: 2% 1% 0% 1%;
  font-family: "helvetica-neue-roman", "Helvetica", "Arial", "sans-serif";
  font-size: 1.5em;
  color: black;
}
.center {
  margin: auto !important;
  width: 99% !important;
  padding: 3px !important;
}
.centered {
  position: absolute;
  top: 50%;
  /* transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%); */
  right: 0;
  left: 0;
  vertical-align: middle;
}
.marta-blue {
  background-color: #0092d0;
}
.marta-gold {
  background-color: #fdbe43;
}
.marta-orange {
  background-color: #ff7500;
}
.text-field {
  font-size: 1.7em !important;
}
#left-content {
  padding-right: 5%;
}
#blue-box-header {
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif" !important;
  font-size: 1.9vw;
  padding-top: 0%;
  margin-top: 0%;
}
#blue-box-subheader {
  font-family: "lemon-milk", "Helvetica", "Arial", "sans-serif" !important;
  font-size: 1vw;
  padding-top: 17%;
  padding-bottom: 0%;
  margin-bottom: 0%;
}
#card-height {
  height: 450px;
}
/* X-small phones */
@media only screen and (max-width: 375px) {
  #blue-box-header {
    font-size: 1.9vw;
  }
  #blue-box-subheader {
    font-size: 1vw;
  }
  .blue-text {
    font-size: 1.3em;
  }
}
/* Smaller phones */
@media only screen and (min-width: 375px) and (max-width: 425px) {
  #blue-box-header {
    font-size: 1.9em;
  }
  #blue-box-subheader {
    margin-top: 1%;
    font-size: 1em;
  }
  .blue-text {
    font-size: 1.3em;
  }
}
/* Large phones */
/* xs */
@media only screen and (min-width: 425px) and (max-width: 600px) {
  #blue-box-header {
    font-size: 1.9vw;
  }
  #blue-box-subheader {
    font-size: 1vw;
  }
  .blue-text {
    font-size: 1.5em;
  }
}
/* Small to medium tablet */
/* sm */
@media only screen and (min-width: 600px) and (max-width: 960px) {
  #blue-box-header {
    font-size: 1.9vw;
  }
  #blue-box-subheader {
    font-size: 1vw;
  }
  .blue-text {
    font-size: 1.5em;
  }
}
@media only screen and (max-width: 425px) {
  #main {
    padding-top: 35% !important;
  }
}
@media only screen and (min-width: 425px) and (max-width: 600px) {
  #main {
    padding-top: 15% !important;
  }
}
@media only screen and (min-width: 600px) and (max-width: 960px) {
  #main {
    padding-top: 20% !important;
  }
}
</style>
